import BaseMystery from '../BaseMystery'

const ThirdLuminousMystery = () => {
	const imagesList = [
		// Sermon on the Mount
		"https://www.wga.hu/art/r/rosselli/cosimo/sermon.jpg",
		"https://www.wga.hu/art/r/ricci/sebastia/2/sermon.jpg",
		"https://www.wga.hu/art/b/bloch/christ1.jpg",
		"https://upload.wikimedia.org/wikipedia/commons/c/cb/Yelin-bergpredigt-ca1912.jpg",
		// Calling the Apostles
		"https://upload.wikimedia.org/wikipedia/commons/a/ac/Ghirlandaio%2C_Domenico_-_Calling_of_the_Apostles_-_1481.jpg",
		// Lazarus
		"https://upload.wikimedia.org/wikipedia/commons/b/bb/Jean-Baptiste_Jouvenet_-_The_Raising_of_Lazarus_-_WGA12033.jpg",
	];

	const scriptureQuote = "He went around all of Galilee, teaching in their synagogues, proclaiming the gospel of the kingdom, and curing every disease and illness among the people.";
	const scriptureCitation = "Matthew 4:23 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Matthew%204%3A17-25&version=NABRE";

	return (
		<BaseMystery titleText="The Proclamation of the Kingdom of God"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default ThirdLuminousMystery;